(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6803],{

/***/ 8087:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/brands",
      function () {
        return __webpack_require__(1424);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 7184:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CarouselArrow; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4337);


function CarouselArrow(param) {
    var onClick = param.onClick, children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_xstyled_styled_components__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xuv, {
        as: "span",
        role: "button",
        "aria-label": "Arrow for toggling between slides",
        onClick: onClick,
        children: children
    });
};


/***/ }),

/***/ 4751:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useScrollRestoration; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);


function useScrollRestoration(param) {
    var data = param.data;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var saveScrollPos = function(url) {
        var scrollPos = {
            x: window.scrollX,
            y: window.scrollY
        };
        sessionStorage.setItem(url, JSON.stringify(scrollPos));
    };
    var restoreScrollPos = function(url) {
        var scrollPos = JSON.parse(sessionStorage.getItem(url));
        if (scrollPos) {
            if (!sessionStorage.getItem("pagination_change")) {
                setTimeout(function() {
                    window.scrollTo({
                        top: scrollPos.y,
                        behavior: "instant"
                    });
                });
            } else {
                sessionStorage.removeItem("pagination_change");
            }
        }
        if (sessionStorage.getItem("pagination_change")) {
            sessionStorage.removeItem("pagination_change");
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if ("scrollRestoration" in window.history && data) {
            var shouldScrollRestore = false;
            window.history.scrollRestoration = "manual";
            restoreScrollPos(router.asPath);
            var onBeforeUnload = function(event) {
                saveScrollPos(router.asPath);
                delete event["returnValue"];
            };
            var onRouteChangeStart = function() {
                saveScrollPos(router.asPath);
            };
            var onRouteChangeComplete = function(url) {
                if (shouldScrollRestore) {
                    shouldScrollRestore = false;
                    restoreScrollPos(url);
                }
            };
            window.addEventListener("beforeunload", onBeforeUnload);
            router.events.on("routeChangeStart", onRouteChangeStart);
            router.events.on("routeChangeComplete", onRouteChangeComplete);
            router.beforePopState(function() {
                shouldScrollRestore = true;
                return true;
            });
            return function() {
                window.removeEventListener("beforeunload", onBeforeUnload);
                router.events.off("routeChangeStart", onRouteChangeStart);
                router.events.off("routeChangeComplete", onRouteChangeComplete);
                router.beforePopState(function() {
                    return true;
                });
            };
        }
    }, [
        data
    ]);
};


/***/ }),

/***/ 1424:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Brands; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./utils/getAlphabet.js
function getAlphabet() {
    var alpha = Array.from(Array(26)).map(function(_e, i) {
        return i + 65;
    });
    return alpha.map(function(x) {
        return String.fromCharCode(x);
    });
};

// EXTERNAL MODULE: ./hooks/UI/useScrollRestoration.js
var useScrollRestoration = __webpack_require__(4751);
// EXTERNAL MODULE: ./components/SEO.js
var SEO = __webpack_require__(9831);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/swiper/esm/react/swiper-slide.js
var swiper_slide = __webpack_require__(4002);
// EXTERNAL MODULE: ./components/UI/Primitives/CarouselArrow.js
var CarouselArrow = __webpack_require__(7184);
// EXTERNAL MODULE: ./components/UI/Icons/index.js
var Icons = __webpack_require__(9430);
// EXTERNAL MODULE: ./node_modules/@xstyled/styled-components/dist/styled-components.esm.js
var styled_components_esm = __webpack_require__(4337);
// EXTERNAL MODULE: ./node_modules/swiper/esm/react/swiper.js + 8 modules
var swiper = __webpack_require__(9447);
// EXTERNAL MODULE: ./components/UI/utils.js
var utils = __webpack_require__(1040);
;// CONCATENATED MODULE: ./components/Brands/styles.js
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  padding: 4rem 0;\n  min-height: 40vh;\n\n  @media (max-width: desktop) {\n    min-height: 100vh;\n    padding: 0 1rem 4rem;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  margin-top: 2rem;\n\n  span {\n    margin-right: 1rem;\n    text-transform: uppercase;\n    font-weight: 700;\n    color: #242424;\n    cursor: pointer;\n\n    &:hover {\n      color: #54c8e6;\n    }\n  }\n\n  @media (max-width: desktop) {\n    display: none;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  margin-top: 2.25rem;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  display: grid;\n  grid-template-columns: 60px 1fr;\n  margin-bottom: 3rem;\n  border: 0.7px solid #d8d9e5;\n  border-radius: 22px;\n  overflow: hidden;\n\n  span {\n    padding: 1rem 0 0 1rem;\n    color: teal-400;\n    font-size: large;\n    font-weight: 700;\n    text-transform: uppercase;\n  }\n\n  @media (max-width: desktop) {\n    display: flex;\n\n    span {\n      padding: 1rem 2rem 0 1rem;\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n\n  flex-direction: column;\n  margin-right: 2rem;\n\n  @media (max-width: desktop) {\n    margin-bottom: 2rem;\n  }\n\n  @media (min-width: desktop) {\n    margin-right: 1rem;\n  }\n\n  p {\n    white-space: nowrap;\n  }\n\n  img {\n    object-fit: contain;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n\n  span:first-of-type {\n    margin: 2rem 0 0.5rem;\n\n    @media (min-width: desktop) {\n      display: none;\n    }\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  font-weight: 700;\n  color: ",
        ";\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n\n  @media (min-width: desktop) {\n    display: none;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  width: 80vw;\n  margin-top: 0.5rem;\n\n  .swiper-slide {\n    display: block;\n    width: auto;\n\n    span {\n      font-size: 18px;\n    }\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  bottom: 0.25rem;\n  right: ",
        ";\n  padding-left: ",
        ";\n  z-index: 1;\n  background-color: white;\n\n  svg {\n    transform: scale(0.7);\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}



var BrandsContainer = styled_components_esm/* default.section */.ZPm.section(_templateObject());
var Alphabet = styled_components_esm/* default.div */.ZPm.div(_templateObject1());
var BrandsByLetter = styled_components_esm/* default.div */.ZPm.div(_templateObject2());
var BrandsBox = styled_components_esm/* default.divBox */.ZPm.divBox(_templateObject3());
var SingleBrand = styled_components_esm/* default.div */.ZPm.div(_templateObject4(), utils/* FlexCenter */.Lb);
// Alphabet carousel
var SelectionContainer = styled_components_esm/* default.div */.ZPm.div(_templateObject5());
var Alpha = styled_components_esm/* default.span */.ZPm.span(_templateObject6(), function(param) {
    var selected = param.selected;
    return selected ? "#54C8E6" : "#242424";
});
var AlphabetSwiperContainer = styled_components_esm/* default.div */.ZPm.div(_templateObject7());
var AlphabetSwiper = (0,styled_components_esm/* default */.ZPm)(swiper/* Swiper */.t)(_templateObject8());
var Arrow = styled_components_esm/* default.div */.ZPm.div(_templateObject9(), function(param) {
    var prev = param.prev;
    return prev && "0.5rem";
}, function(param) {
    var next = param.next;
    return next && "0.5rem";
});

;// CONCATENATED MODULE: ./components/Brands/AlphabetSwiper.js







function AlphabetCarousel() {
    var swiperRef = (0,react.useRef)(null);
    var ref2 = (0,react.useState)(null), selected = ref2[0], setSelected = ref2[1];
    var ref1 = (0,react.useState)({
        left: false,
        right: true
    }), arrows = ref1[0], setArrows = ref1[1];
    var alphabet = getAlphabet();
    var scrollToAlpha = function(alpha) {
        setSelected(alpha);
        var element = document.getElementById(alpha);
        element.scrollIntoView();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SelectionContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: "K\xf5ik br\xe4ndid"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(AlphabetSwiperContainer, {
                children: [
                    arrows.left && /*#__PURE__*/ (0,jsx_runtime.jsx)(Arrow, {
                        prev: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CarouselArrow/* default */.Z, {
                            onClick: function() {
                                var ref;
                                return (ref = swiperRef.current) === null || ref === void 0 ? void 0 : ref.swiper.slidePrev();
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* SliderArrowLeft */.wT, {
                                strokeWidth: 5
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AlphabetSwiper, {
                        ref: swiperRef,
                        freemode: "true",
                        slidesPerView: "auto",
                        spaceBetween: 16,
                        onFromEdge: function() {
                            setArrows({
                                left: true,
                                right: true
                            });
                        },
                        onReachBeginning: function() {
                            setArrows({
                                left: false,
                                right: true
                            });
                        },
                        onReachEnd: function() {
                            setArrows({
                                left: true,
                                right: false
                            });
                        },
                        children: alphabet.map(function(alpha) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_slide/* SwiperSlide */.o, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Alpha, {
                                    role: "button",
                                    "aria-label": "Select brand letter",
                                    selected: selected === alpha,
                                    onClick: function() {
                                        return scrollToAlpha(alpha);
                                    },
                                    children: alpha.toUpperCase()
                                })
                            }, alpha);
                        })
                    }),
                    arrows.right && /*#__PURE__*/ (0,jsx_runtime.jsx)(Arrow, {
                        next: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CarouselArrow/* default */.Z, {
                            onClick: function() {
                                var ref;
                                return (ref = swiperRef.current) === null || ref === void 0 ? void 0 : ref.swiper.slideNext();
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* SliderArrowRight */.C$, {
                                strokeWidth: 5
                            })
                        })
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/UI/Image/index.js
var Image = __webpack_require__(9696);
// EXTERNAL MODULE: ./components/UI/Layout/index.js
var Layout = __webpack_require__(3793);
// EXTERNAL MODULE: ./components/UI/Layout/Container.js
var Container = __webpack_require__(6094);
// EXTERNAL MODULE: ./components/UI/Primitives/Headings.js
var Headings = __webpack_require__(7133);
// EXTERNAL MODULE: ./components/UI/Primitives/FlexBox.js
var FlexBox = __webpack_require__(5653);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 68 modules
var esm = __webpack_require__(5260);
;// CONCATENATED MODULE: ./pages/brands/index.js













var __N_SSG = true;
function Brands(param) {
    var brands = param.brands, categories = param.categories;
    var t = (0,esm/* useTranslation */.$G)().t;
    // Add safety checks
    if (!brands || !Array.isArray(brands)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
            categories: categories,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SEO/* default */.Z, {
                    seo: {
                        title: "Brands - Baltbaby",
                        description: "Baltbaby e-poes on suur valik k\xf5rgelt hinnatud beebi- ja lastekaupade br\xe4nde."
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(BrandsContainer, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* Container */.W, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Headings/* SectionTitleSmall */.Kg, {
                                children: "Br\xe4ndid"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Br\xe4nde ei ole hetkel saadaval"
                            })
                        ]
                    })
                })
            ]
        });
    }
    var groupBrands = brands.reduce(function(alpha, brand) {
        // Safety checks
        if (!(brand === null || brand === void 0 ? void 0 : brand.value) || typeof brand.value !== "string" || brand.value.length === 0) {
            return alpha;
        }
        var group = brand.value[0].toLowerCase();
        if (!alpha[group]) {
            alpha[group] = {
                group: group,
                children: [
                    brand
                ]
            };
        } else {
            alpha[group].children.push(brand);
        }
        return alpha;
    }, {}); // ← Fixed: object instead of array
    var brandsOfAlpha = function(alpha) {
        if (!groupBrands || !alpha) return null;
        return groupBrands[alpha.toLowerCase()];
    };
    var abc = getAlphabet();
    var alphabet = abc.filter(function(alpha) {
        var brandsGroup = brandsOfAlpha(alpha);
        return brandsGroup && brandsGroup.children.some(function(item) {
            return item.product_quantity && item.product_quantity > 0;
        });
    });
    var scrollToAlpha = function(alpha) {
        var element = document.getElementById(alpha);
        element === null || element === void 0 ? void 0 : element.scrollIntoView({
            behavior: "smooth"
        });
    };
    // Restore scroll position when returning from a specific brand
    // useScrollRestoration({ data: brands });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
        categories: categories,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SEO/* default */.Z, {
                seo: {
                    title: t("header.brands") + " - Baltbaby",
                    description: "Baltbaby e-poes on suur valik k\xf5rgelt hinnatud beebi- ja lastekaupade br\xe4nde. Thule, Easywalker, Baby Jogger, Maxi-Cosi ja palju muud."
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BrandsContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* Container */.W, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Headings/* SectionTitleSmall */.Kg, {
                            children: t("header.brands")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AlphabetCarousel, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Alphabet, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FlexBox/* FlexBox */.h, {
                                children: alphabet === null || alphabet === void 0 ? void 0 : alphabet.map(function(alpha) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        role: "button",
                                        onClick: function() {
                                            return scrollToAlpha(alpha);
                                        },
                                        style: {
                                            cursor: "pointer"
                                        },
                                        children: alpha
                                    }, alpha);
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BrandsByLetter, {
                            children: alphabet === null || alphabet === void 0 ? void 0 : alphabet.map(function(alpha) {
                                var brandsGroup = brandsOfAlpha(alpha);
                                if (!(brandsGroup === null || brandsGroup === void 0 ? void 0 : brandsGroup.children)) return null;
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BrandsBox, {
                                    id: alpha,
                                    p: {
                                        _: "30px 0 0 0",
                                        desktop: "20px 0"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: alpha
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FlexBox/* FlexBox */.h, {
                                            display: "grid",
                                            gridTemplateColumns: {
                                                _: "repeat(2, 1fr)",
                                                mobile: "repeat(2, 1fr)",
                                                sm_tablet: "repeat(4, 1fr)",
                                                lg_tablet: "repeat(6, 1fr)",
                                                desktop: "repeat(7, 1fr)"
                                            },
                                            rowGap: "2rem",
                                            maxW: {
                                                _: "100%",
                                                desktop: 1000
                                            },
                                            children: brandsGroup.children.filter(function(item) {
                                                return (item === null || item === void 0 ? void 0 : item.product_quantity) > 0;
                                            }).map(function(brand) {
                                                if (!(brand === null || brand === void 0 ? void 0 : brand.url_key) || !(brand === null || brand === void 0 ? void 0 : brand.value)) return null;
                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SingleBrand, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            href: "/brands/".concat(brand.url_key, "?id=").concat(brand.option_id),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                                                    src: brand.image,
                                                                    alt: brand.value,
                                                                    width: 92,
                                                                    height: 92
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                            children: [
                                                                brand.product_quantity,
                                                                " ",
                                                                brand.product_quantity > 1 ? "toodet" : "toode"
                                                            ]
                                                        })
                                                    ]
                                                }, brand.url_key);
                                            })
                                        })
                                    ]
                                }, alpha);
                            })
                        })
                    ]
                })
            })
        ]
    });
};


/***/ }),

/***/ 4002:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ SwiperSlide; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1077);
/* harmony import */ var _use_isomorphic_layout_effect__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7254);
var _excluded = ["tag", "children", "className", "swiper", "zoom", "virtualIndex"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }




var SwiperSlide = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_temp, externalRef) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$tag = _ref.tag,
      Tag = _ref$tag === void 0 ? 'div' : _ref$tag,
      children = _ref.children,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      swiper = _ref.swiper,
      zoom = _ref.zoom,
      virtualIndex = _ref.virtualIndex,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);

  var slideElRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)('swiper-slide'),
      slideClasses = _useState[0],
      setSlideClasses = _useState[1];

  function updateClasses(swiper, el, classNames) {
    if (el === slideElRef.current) {
      setSlideClasses(classNames);
    }
  }

  (0,_use_isomorphic_layout_effect__WEBPACK_IMPORTED_MODULE_1__/* .useIsomorphicLayoutEffect */ .L)(function () {
    if (externalRef) {
      externalRef.current = slideElRef.current;
    }

    if (!slideElRef.current || !swiper) {
      return;
    }

    if (swiper.destroyed) {
      if (slideClasses !== 'swiper-slide') {
        setSlideClasses('swiper-slide');
      }

      return;
    }

    swiper.on('_slideClass', updateClasses); // eslint-disable-next-line

    return function () {
      if (!swiper) return;
      swiper.off('_slideClass', updateClasses);
    };
  });
  (0,_use_isomorphic_layout_effect__WEBPACK_IMPORTED_MODULE_1__/* .useIsomorphicLayoutEffect */ .L)(function () {
    if (swiper && slideElRef.current) {
      setSlideClasses(swiper.getSlideClasses(slideElRef.current));
    }
  }, [swiper]);
  var slideData;

  if (typeof children === 'function') {
    slideData = {
      isActive: slideClasses.indexOf('swiper-slide-active') >= 0 || slideClasses.indexOf('swiper-slide-duplicate-active') >= 0,
      isVisible: slideClasses.indexOf('swiper-slide-visible') >= 0,
      isDuplicate: slideClasses.indexOf('swiper-slide-duplicate') >= 0,
      isPrev: slideClasses.indexOf('swiper-slide-prev') >= 0 || slideClasses.indexOf('swiper-slide-duplicate-prev') >= 0,
      isNext: slideClasses.indexOf('swiper-slide-next') >= 0 || slideClasses.indexOf('swiper-slide-duplicate-next') >= 0
    };
  }

  var renderChildren = function renderChildren() {
    return typeof children === 'function' ? children(slideData) : children;
  };

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Tag, _extends({
    ref: slideElRef,
    className: (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .uniqueClasses */ .kI)("" + slideClasses + (className ? " " + className : '')),
    "data-swiper-slide-index": virtualIndex
  }, rest), zoom ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "swiper-zoom-container",
    "data-swiper-zoom": typeof zoom === 'number' ? zoom : undefined
  }, renderChildren()) : renderChildren());
});
SwiperSlide.displayName = 'SwiperSlide';


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4337,1664,7536,9669,5675,3305,9447,2483,5275,1979,9085,9774,2888,179], function() { return __webpack_exec__(8087); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);